import { render, staticRenderFns } from "./Visualizar_Fichero_Para_Copiar.vue?vue&type=template&id=52c81cdc&scoped=true"
import script from "./Visualizar_Fichero_Para_Copiar.vue?vue&type=script&lang=js"
export * from "./Visualizar_Fichero_Para_Copiar.vue?vue&type=script&lang=js"
import style0 from "./Visualizar_Fichero_Para_Copiar.vue?vue&type=style&index=0&id=52c81cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c81cdc",
  null
  
)

export default component.exports